<template>
    <div class="container-fluid" v-if="user">
        <div class="row">
            <div class="col-md-12 mb-2">
                <router-link :to="$laravelRoute('favourites.index', {'user_id':user.id}, false)" class="link">Favourites</router-link>
                <router-link v-if="$userIsRole('admin')" :to="$laravelRoute('user-bid.index', {'rep_id':user.id}, false)" class="link">Bids</router-link>
                <router-link v-else :to="$laravelRoute('user-bid.index', {'filter_user_ids':user.id}, false)" class="link">Bids</router-link>
                <a :href="$laravelRoute('history.by-user', {'user':user.id}, false)" class="link">Activity</a>
                <router-link :to="$laravelRoute('saved-search.index', {'user_id':user.id}, false)" class="link">Saved Searches</router-link>
                <router-link :to="$laravelRoute('recommended.index', {'user_id':user.id}, false)" class="link">Recommended</router-link>
                <router-link :to="$laravelRoute('auto-notices.index', {'user_id':user.id}, false)" class="link">Auto Notices</router-link>
                <router-link :to="$laravelRoute('vehicle-stock.myGarage', {'user_id':user.id}, false)" class="link">My Stock</router-link>
                <router-link v-if="$userIsAdmin()" :to="$laravelRoute('users.edit', user.id, false)" class="link">Edit</router-link>
            </div>
            <div class="col-md-4">
                <p>
                    <strong>Company: </strong>
                    <template v-if="user.company"> {{user.company.name}} </template>
                </p>
                <p><strong>First name: </strong> {{user.first_name}}</p>
                <p><strong>Last name: </strong> {{user.last_name}}</p>
                <p><strong>Status: </strong>
                    <template v-if="user.status">{{user.status.name}}</template>
                </p>
                <p><strong>Role: </strong>
                    <template v-if="user.role">{{user.role.name}}</template>
                </p>
                <p>
                    <strong>Email: </strong>
                    <a :href="`mailto:${user.email}`" target="_blank">
                        {{user.email}}
                    </a>
                </p>
                <template v-if="user.profile">
                    <p><strong>Phone: </strong> {{user.profile.phone}}</p>
                    <p><strong>Fax: </strong> {{user.profile.fax}}</p>
                    <p><strong>Mobile: </strong> {{user.profile.mobile}}</p>
                    <p><strong>Address: </strong> {{user.profile.address}}</p>
                    <p><strong>City: </strong> {{user.profile.city}}</p>
                    <p><strong>Post Code: </strong> {{user.profile.post_code}}</p>
                    <p>
                        <strong>Country: </strong>
                        <template v-if="user.country">{{user.country.name}}</template>
                    </p>
                    <p><strong>Customer Region: </strong>
                        <template v-if="user.profile.region">{{user.profile.region}}</template>
                    </p>
                </template>
            </div>
            <div class="col-md-4">
                <p><strong>Username: </strong> {{user.username}}</p>
                <p>
                    <strong>Sales Rep: </strong>
                    <a v-if="user.sales_rep" :href="$laravelRoute('users.show', user.sales_rep_id)">{{user.sales_rep.name}}</a>
                </p>
                <p><strong>Last Activity: </strong> {{user.last_activity}}</p>
                <p><strong>User ID </strong> {{user.id}}</p>
                <p><strong>Owner Key: </strong> {{user.ownerkey}}</p>
                <p><strong>Bid Color </strong> {{user.profile.bid_color}}</p>
                <p><strong>Bump bid</strong>
                    <template v-if="user.bump_bid && user.bump_bid.text_array.length">
                        <br />
                        <span v-for="$txt in user.bump_bid.text_array">
                            {{$txt}}
                            <br />
                        </span>

                    </template>
                </p>
            </div>
            <div class="col-md-4">
                <h3>End Consumer Privileges</h3>
                <p>{{user.privileges.enable_auto_notice?'YES':'NO'}} - Enable Auto Notice</p>
                <p>{{user.privileges.enable_market_price?'YES':'NO'}} - Enable Market Price Research</p>
                <h3>Dealer Privileges</h3>
                <p>{{user.privileges.display_auction_result?'YES':'NO'}} - Display Auction Results</p>
                <p>{{user.privileges.enable_email?'YES':'NO'}} - Enable Email</p>
                <p>{{user.privileges.show_auction_site?'YES':'NO'}} - Show Auction Site</p>
                <p>{{user.privileges.show_lot_number?'YES':'NO'}} - Show Lot Number</p>
                <p>{{user.privileges.show_inspection?'YES':'NO'}} - Show Inspection</p>
                <p>{{user.privileges.add_url_logo_image?'YES':'NO'}} - Add URL Logo Image</p>
                <p>{{user.privileges.attended_auctions?'YES':'NO'}} - Attended Auctions</p>
                <p>{{user.privileges.show_history?'YES':'NO'}} - Show History</p>
                <p>{{user.privileges.can_login_as?'YES':'NO'}} - Can Login As Another User</p>
                <p>{{user.privileges.unlimited_login?'YES':'NO'}} - Unlimited Login</p>
            </div>
        </div>

        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-4">
                <strong v-if="user.profile && user.profile.note">Notes: {{user.profile.note}}</strong>
            </div>
            <div class="col-md-4"></div>
        </div>
    </div>
</template>
<script>
    export default {
        props: [
            'user_id'
        ],
        async created() {
            this.user = await this.$store.dispatch('users/getUser', {user_id: this.user_id})
        },
        data() {
            return {
                user: null,
            }
        },
        computed: {
        },
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/User/ShowUser.vue